<template>
    <div :class="customClass ? customClass : ''">
        <div v-if="type === 'global' && isLoading" class="loading-overlay"></div>
        <div :class="{ [loaderType]: isLoading }">
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>
    import isEmpty from 'lodash/isEmpty'

    export default {
        props: {
            data: { type: [Array, Object], required: true },
            customClass: String,

            // Type: Global = For blocking loading interaction, for crucial data
            // Type: Default = For non blocking loading interaction, component loading
            type: { type: String, default: 'default' }
        },
        computed: {
            loaderType() {
              return this.type === 'global' ? 'is-loading global' : 'is-loading';
            },
            isLoading() {
                return isEmpty(this.data)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .loading-overlay {
        content: '';
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: white;
        opacity: 0.5;
        z-index: 20000;
    }

    // Default loader for component
    .is-loading {
        position: absolute;
        width: 100%;
        height: 2px;
        max-width: 1170px;
        overflow: hidden;
        background-color: rgba(41, 41, 41, 0.1);
        left: 50%;
        transform: translateX(-50%);
        z-index: 101;
        &:before{
            display: block;
            position: absolute;
            content: "";
            left: -200px;
            width: 200px;
            height: 2px;
            background-color: $color-alpha;
            animation: loading 2s linear infinite;
        }

        // Global modifications for component
        &.global {
            max-width: 1470px;
            top: 159px;
        }
    }

    @keyframes loading {
        from {left: -200px; width: 30%;}
        50% {width: 30%;}
        70% {width: 70%;}
        80% { left: 50%;}
        95% {left: 120%;}
        to {left: 100%;}
    }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue